/*
 * 项目详细信息组件
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    message,
    Table,
    Input,
    Select,
    Button,
    Progress,
    Checkbox,
    Tag,
    Space,
    Statistic,
    theme,
} from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    winWidth,
    GetDropdownActionName,
    GetArrSpanMaxWidth,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './DetailEntity';
import DetailProgressLogEntity from './DetailProgressLogEntity.js';
import DetailToauditEntity from './DetailToauditEntity';
import DetailAuditedEntity from './DetailAuditedEntity';
import DetailRepaymentEntity from './DetailRepaymentEntity.js';
import DetailArchiveEntity from './DetailArchiveEntity.js';

const MODULENAME = CNF.navItems[0].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[1].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[1].url;

//  项目进度渐变颜色
const progressColors = {
    '0%': '#108ee9',
    '100%': '#87d068',
};
//  项目回款渐变颜色
const repaymentColors = {
    '0%': '#ff0000',
    '100%': '#00ff00',
};

const Lists = (props) => {
    const { btnLists, preGroup, dataLists, currentIndex, pageCount, changeIndex, refresh, qss } = props;

    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorSuccess,
            colorSuccessBg,
            colorWarning,
            colorWarningBg,
            colorError,
            colorErrorBg,
            cyan1,
            cyan6,
            fontSize,
            pageSize,
        },
    } = theme.useToken();

    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [openProgress, setOpenProgress] = useState(false);
    const [openToaudit, setOpenToaudit] = useState(false);
    const [openAudited, setOpenAudited] = useState(false);
    const [openRepayment, setOpenRepayment] = useState(false);
    const [openArchive, setOpenArchive] = useState(false);


    const update = useCallback((open, record = null) => {
        setRecord(record);
        setOpen(open);
    }, []);

    const progress = useCallback((open, record = null) => {
        setRecord(record);
        setOpenProgress(open);
    }, []);

    const toaudit = useCallback((open, record = null) => {
        setRecord(record);
        setOpenToaudit(open);
    }, []);


    const audited = useCallback((open, record = null) => {
        setRecord(record);
        setOpenAudited(open);
    }, []);


    const repayment = useCallback((open, record = null) => {
        setRecord(record);
        setOpenRepayment(open);
    }, []);

    const archive = useCallback((open, record = null) => {
        setRecord(record);
        setOpenArchive(open);
    }, []);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        switch (action) {
            case CNF.actionName.UPDATE:
                update(true, record);
                break;
            case CNF.actionName.PROGRESS:
                progress(true, record);
                break;
            case CNF.actionName.TOAUDIT:
                toaudit(true, record);
                break;
            case CNF.actionName.AUDITED:
                audited(true, record);
                break;
            case CNF.actionName.REPAYMENT:
                repayment(true, record);
                break;
            case CNF.actionName.ARCHIVE:
                archive(true, record);
                break;
            default:
                break;
        }
    }, [update, progress, toaudit, audited, repayment, archive]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_progress') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_audit') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_audited') >= 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_repayment') >= 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_archive') >= 0
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '项目名称', dataIndex: 'name', key: 'name', fixed: 'left', width: GetArrSpanMaxWidth(dataLists, 'name'), },
        { title: '项目编号', dataIndex: 'number', key: 'number', width: 180, },
        { title: '项目类型', dataIndex: 'type', key: 'type', width: 80, },
        { title: '项目阶段', dataIndex: 'phase', key: 'phase', width: 120, },
        { title: '项目区域', dataIndex: 'area', key: 'area', width: 120, },
        {
            title: '项目等级', key: 'rank', width: 120,
            render: function (record) {
                for (let item of CNF.projectRanks) {
                    if (parseInt(record.rank) === parseInt(item.value)) {
                        return item.key
                    }
                }
            }
        },
        {
            title: '项目进度', key: 'progress', width: 180,
            render: (record) => <Progress
                style={{ margin: 0 }}
                size='small' percent={record.progress} strokeColor={progressColors} />

        },
        {
            title: '合同编号', key: 'contract_number', width: 180,
            render: (record) => record.contract_number ? record.contract_number : '-'
        },
        {
            title: '合同签订日期', key: 'contract_date', width: 120,
            render: (record) => record.contract_date ? record.contract_date : '-'
        },
        {
            title: '合同金额(元)', key: 'contract_amount', width: 120,
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '100%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={record.contract_amount} /></Tag>
        },
        {
            title: '送审金额(元)', key: 'audit_amount', width: 120,
            render: (record) => <Tag color={colorWarningBg} style={{ width: '100%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorWarning } }} value={record.audit_amount} /></Tag>
        },
        {
            title: '审定金额(元)', key: 'audited_amount', width: 120,
            render: (record) => <Tag color={colorErrorBg} style={{ width: '100%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorError } }} value={record.audited_amount} /></Tag>
        },
        {
            title: '回款金额(元)', key: 'repayment_amount', width: 120,
            render: (record) => <Tag color={colorSuccessBg} style={{ width: '100%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorSuccess } }} value={record.repayment_amount} /></Tag>
        },
        {
            title: '回款比例(%)', key: 'repayment_percent', width: 180,
            render: (record) => <Progress
                style={{ margin: 0 }}
                size='small'
                percent={record.repayment_amount ? (100 * record.repayment_amount / (record.audited_amount > 0 ? record.audited_amount : record.contract_amount)).toFixed(CNF.DPL) : 0.00}
                strokeColor={repaymentColors} />
        },
        {
            title: '待收金额(元)', key: 'unpaid_amount', width: 120,
            render: (record) => <Tag color={cyan1} style={{ width: '100%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: cyan6 } }} value={record.unpaid_amount} /></Tag>
        },
        {
            title: '送审时间', key: 'audit_date', width: 120,
            render: (record) => record.audit_date ? record.audit_date : '-'
        },
        {
            title: '审定时间', key: 'audited_date', width: 120,
            render: (record) => record.audited_date ? record.audited_date : '-'
        },
        {
            title: '审计单位', key: 'audit_unit', width: GetArrSpanMaxWidth(dataLists, 'audit_unit'),
            render: (record) => record.audit_unit ? record.audit_unit : '-'
        },
        {
            title: '审计状态', dataIndex: 'audit_status', key: 'audit_status', width: CNF.tableStatusColumnWidth,
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', dataIndex: 'status', key: 'status', fixed: 'right', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [
        btnLists,
        dataLists,
        colorPrimary,
        colorPrimaryBg,
        colorSuccess,
        colorSuccessBg,
        hasOpPerm,
        operation,
        colorError,
        colorErrorBg,
        colorWarning,
        colorWarningBg,
        cyan1,
        cyan6,
        fontSize,
    ]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                scroll={{ x: winWidth }}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => <>
                        合同金额: <Tag color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix={qss?.contract_amount > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={qss?.contract_amount >= 10000 ? qss?.contract_amount / 10000 : qss?.contract_amount} /></Tag>
                        回款金额: <Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={qss?.repayment_amount > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: colorSuccess } }} value={qss?.repayment_amount >= 10000 ? qss?.repayment_amount / 10000 : qss?.repayment_amount} /></Tag>
                        待收金额: <Tag color={cyan1}><Statistic precision={CNF.DPL} suffix={qss?.unpaid_amount > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: cyan6 } }} value={qss?.unpaid_amount >= 10000 ? qss?.unpaid_amount / 10000 : qss?.unpaid_amount} /></Tag>
                        共{pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条
                    </>,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {
                record && <Entity
                    preGroup={preGroup}
                    btnLists={btnLists}
                    open={open}
                    record={record}
                    setOpen={setOpen}
                    refresh={refresh}
                />
            }
            {
                record && <DetailProgressLogEntity
                    preGroup={preGroup}
                    open={openProgress}
                    setOpen={setOpenProgress}
                    record={record}
                    refresh={refresh}
                    action={CNF.actionName.CREATE}

                />
            }
            {
                record && <DetailToauditEntity
                    preGroup={preGroup}
                    open={openToaudit}
                    setOpen={setOpenToaudit}
                    record={record}
                    refresh={refresh}
                />
            }
            {
                record && <DetailAuditedEntity
                    preGroup={preGroup}
                    open={openAudited}
                    setOpen={setOpenAudited}
                    record={record}
                    refresh={refresh}
                />
            }
            {
                record && <DetailRepaymentEntity
                    preGroup={preGroup}
                    btnLists={btnLists}
                    open={openRepayment}
                    setOpen={setOpenRepayment}
                    record={record}
                    refresh={refresh}
                    action={CNF.actionName.CREATE}
                />
            }
            {
                record && <DetailArchiveEntity
                    preGroup={preGroup}
                    open={openArchive}
                    setOpen={setOpenArchive}
                    record={record}
                    refresh={refresh}
                />
            }
        </>
    );
}

const ProjectDetail = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [status, setStatus] = useState(CNF.status[0].value);

    const [qss, setQss] = useState(null);
    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [type, setType] = useState('');
    const [phase, setPhase] = useState('');
    const [rank, setRank] = useState(0);
    const [area, setArea] = useState('');
    const [auditStatus, setAuditStatus] = useState('');
    const [isUnfinish, setIsUnfinish] = useState(1);

    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleNameChange = useCallback((e) => {
        setName(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleNumberChange = useCallback((e) => {
        setNumber(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleTypeChange = useCallback((value) => {
        setType(value);
        setCurrentIndex(1);
    }, []);

    const handlePhaseChange = useCallback((value) => {
        setPhase(value);
        setCurrentIndex(1);
    }, []);

    const handleRankChange = useCallback((value) => {
        setRank(value);
        setCurrentIndex(1);
    }, []);

    const handleAreaChange = useCallback((e) => {
        setArea(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleAuditStatusChange = useCallback((value) => {
        setAuditStatus(value);
        setCurrentIndex(1);
    }, []);

    const handleIsUnfinishChange = useCallback((e) => {
        setIsUnfinish(e.target.checked ? 1 : 0);
        setCurrentIndex(1);
    }, []);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            name,
            number,
            phase,
            type,
            rank,
            area,
            audit_status: auditStatus,
            is_unfinish: isUnfinish,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
                setQss(data.qss || null);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, name, number,
        phase,
        type,
        rank,
        area,
        auditStatus,
        isUnfinish
    ]);

    /***
    * 导出为 Excel
    */
    const exportAsExecl = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目详细信息-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目详细信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '项目名称',
                    '项目编号',
                    '项目类型',
                    '项目阶段',
                    '项目区域',
                    '项目等级',
                    '项目进度(%)',
                    '合同编号',
                    '合同签订日期',
                    '合同金额(元)',
                    '送审金额(元)',
                    '审定金额(元)',
                    '回款金额(元)',
                    '待收金额(元)',
                    '送审时间',
                    '审定时间',
                    '审计单位',
                    '备注',
                    '状态'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出项目基础信息明细
     */
    const exportGetData = () => {
        let params = {
            page_size: CNF.maxPageSize,
            current_index: currentIndex,
            status,
            name,
            number,
            phase,
            type,
            rank,
            area,
            audit_status: auditStatus,
            is_unfinish: isUnfinish,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}project/details${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    // 删除非必须字段
                    var d = [];
                    for (let i = 0; i < data.dat.length; i++) {
                        var item = data.dat[i]
                        delete item['key'];
                        delete item['type_ulid'];
                        delete item['project_ulid'];
                        delete item['create_username'];
                        delete item['create_displayname'];
                        delete item['create_time'];
                        delete item['update_time'];
                        for (let i of CNF.projectRanks) {
                            if (parseInt(item['rank']) === parseInt(i.value)) {
                                item['rank'] = i.key;
                            }
                        }
                        d.push(item);
                    }
                    exportAsExecl(d);
                } else {
                    exportAsExecl([]);
                }
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }

    // 按钮权限判断
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input

                    placeholder='项目名称'
                    value={name}
                    onChange={handleNameChange}
                />
                <Input
                    placeholder='项目编码'
                    value={number}
                    onChange={handleNumberChange}
                />
                <Select
                    allowClear
                    placeholder='项目类型'
                    onChange={handleTypeChange}
                    options={CNF.projectTypes.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <Select
                    allowClear
                    placeholder='项目阶段'
                    onChange={handlePhaseChange}
                    options={CNF.projectPhases.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <Input
                    placeholder='项目区域'
                    value={area}
                    onChange={handleAreaChange}
                />
                <Select
                    allowClear
                    placeholder='项目等级'
                    onChange={handleRankChange}
                    options={CNF.projectRanks.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <Select
                    allowClear
                    placeholder='审计状态'
                    popupMatchSelectWidth={false}
                    onChange={handleAuditStatusChange}
                    value={auditStatus || undefined}
                    options={CNF.auditStatus.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    popupMatchSelectWidth={false}
                    onChange={handleStatusChange}
                    value={status || undefined}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                <Checkbox
                    disabled={loading}
                    checked={isUnfinish}
                    onChange={handleIsUnfinishChange}>
                    未结束
                </Checkbox>
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                preGroup={preGroup}
                btnLists={btnLists}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                refresh={refresh}
                qss={qss}
            />
        </>
    );
}

export default ProjectDetail;